(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/system.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/system.js'); 
(function() {
  var activeSelectorClass =
    svs.tipset.data.gameDefinitions.htmlClass + '-system-selector-active';

  svs.tipset.views.System = Backbone.Marionette.View.extend({
    className: 'centered modal-bottom-padding',
    tagName: 'div',
    ui: {
      noSystemBtn: '.js-btn-systemtype[data-value=0]',
      rSystem: '#rsystem',
      rSystemBtn: '#rSystemBtn',
      rSystemArrow: '.rSystemArrow',
      uSystem: '#usystem',
      uSystemBtn: '#uSystemBtn',
      uSystemArrow: '.uSystemArrow',
      systemTypeBtn: '.js-btn-systemtype', 
      systemBtn: '.js-btn-system',
      freeReduceBtn: '#freeReduceBtn'
    },
    events: {
      'click @ui.systemTypeBtn': 'onSystemTypeClick',
      'click @ui.systemBtn': 'onSystemClick',
      'click .js-help-dialog-r-system': 'helpDialogRSystem',
      'click .js-help-dialog-u-system': 'helpDialogUSystem'
    },
    tmpSystem: null, 
    system: null, 

    initialize: function() {
      this.uid = svs.tipset.getUid();
      if (!svs.tipset.models.systems) {
        svs.tipset.models.systems = new svs.tipset.models.Systems();
      }
      this.update();
    },

    update: function() {
      this.tmpSystem = this.model.getCurrentSystem();
    },

    onSystemTypeClick: function(e) {

      switch ($(e.currentTarget).data('value')) {
        case 1:
          this.ui.rSystem.toggle();
          if (this.ui.rSystem.css('display') == 'block') {
            $(e.currentTarget).data('open', true);
            this.ui.rSystemBtn.removeClass('panel-heading-white');
            this.ui.rSystemArrow
              .removeClass('icon-menu-down')
              .addClass('icon-menu-up');
          } else {
            $(e.currentTarget).data('open', false);
            if (this.tmpSystem === null || this.tmpSystem.type !== 'R') {
              this.ui.rSystemBtn.addClass('panel-heading-white');
            } else {
              this.ui.rSystemArrow
                .addClass('fc-white')
                .removeClass('icon-default');
            }
            this.ui.rSystemArrow
              .removeClass('icon-menu-up')
              .addClass('icon-menu-down');
          }
          break;

        case 2:
          this.ui.uSystem.toggle();
          if (this.ui.uSystem.css('display') == 'block') {
            this.ui.uSystemBtn.data('open', true);
            this.ui.uSystemBtn.removeClass('panel-heading-white');
            this.ui.uSystemArrow
              .removeClass('icon-menu-down')
              .addClass('icon-menu-up');
          } else {
            this.ui.uSystemBtn.data('open', false);
            if (this.tmpSystem === null || this.tmpSystem.type !== 'U') {
              this.ui.uSystemBtn.addClass('panel-heading-white');
            } else {
              this.ui.uSystemArrow
                .addClass('fc-white')
                .removeClass('icon-default');
            }
            this.ui.uSystemArrow
              .removeClass('icon-menu-up')
              .addClass('icon-menu-down');
          }
          break;

        case 3: 
          $('.sname').text('');
          $('#tips-area').removeAttr('style');
          if (this.system) {
            this.system.prop('checked', false);
          } else {
            this.ui.systemBtn.filter(':checked').prop('checked', false);
          }

          if (this.ui.freeReduceBtn.hasClass(activeSelectorClass)) {
            this.ui.freeReduceBtn.addClass('panel-heading-white');
            this.ui.freeReduceBtn.removeClass(activeSelectorClass);
          } else {
            this.tmpSystem = 'reduce-free';
            this.ui.freeReduceBtn.removeClass('panel-heading-white');
            this.ui.freeReduceBtn.addClass(activeSelectorClass);
            this.ui.rSystemBtn.removeClass(activeSelectorClass);
            this.ui.uSystemBtn.removeClass(activeSelectorClass);
            this.ui.noSystemBtn.removeClass(activeSelectorClass);
            this.ui.noSystemBtn.addClass('panel-heading-white');
            this.ui.rSystemBtn.addClass('panel-heading-white');
            this.ui.uSystemBtn.addClass('panel-heading-white');
            this.ui.rSystemArrow
              .addClass('icon-default')
              .removeClass('fc-white');
            this.ui.uSystemArrow
              .addClass('icon-default')
              .removeClass('fc-white');
          }
          break;

        default:
          this.tmpSystem = null;
          $('.sname').text('');
          $('#tips-area').removeAttr('style');
          if (this.system) {
            this.system.prop('checked', false);
          } else {
            this.ui.systemBtn.filter(':checked').prop('checked', false);
          }

          this.ui.rSystemBtn.removeClass(activeSelectorClass);
          this.ui.uSystemBtn.removeClass(activeSelectorClass);
          this.ui.freeReduceBtn.removeClass(activeSelectorClass);

          if (
            !this.ui.rSystemBtn.data('open') ||
            (this.model.getCurrentSystem() || {}).type === 'R'
          ) {
            this.ui.rSystemBtn.addClass('panel-heading-white');
          }
          if (
            !this.ui.uSystemBtn.data('open') ||
            (this.model.getCurrentSystem() || {}).type === 'U'
          ) {
            this.ui.uSystemBtn.addClass('panel-heading-white');
          }
          this.ui.freeReduceBtn.addClass('panel-heading-white');
          this.ui.rSystemArrow.addClass('icon-default').removeClass('fc-white');
          this.ui.uSystemArrow.addClass('icon-default').removeClass('fc-white');

          this.ui.noSystemBtn
            .removeClass('panel-heading-white')
            .addClass(activeSelectorClass);
      }

      this.trigger('modalContentResize');
      return false;
    },

    onSystemClick: function(e) {
      this.system = $(e.currentTarget);
      var system = $(e.currentTarget).data('object');
      this.tmpSystem = system;

      this.ui.systemTypeBtn.removeClass(activeSelectorClass);
      this.ui.systemTypeBtn.addClass('panel-heading-white');

      this.ui.systemTypeBtn
        .filter(function() {
          return $(this).data('open') == true;
        })
        .removeClass('panel-heading-white');

      if (system.type == 'R') {
        this.ui.rSystemBtn.removeClass('panel-heading-white');
        this.ui.rSystemBtn.addClass(activeSelectorClass);

        this.ui.uSystemArrow.removeClass('fc-white').addClass('icon-default');
        if (this.ui.uSystemBtn.data('open') === false) {
          this.ui.uSystemBtn.addClass('panel-heading-white');
        }

        this.ui.rSystemArrow.addClass('fc-white').removeClass('icon-default');

        $('#rsystemname').text(': ' + this.model.getSystemName());
        $('#usystemname').text('');
      } else {
        this.ui.uSystemBtn.removeClass('panel-heading-white');
        this.ui.uSystemBtn.addClass(activeSelectorClass);

        this.ui.rSystemArrow.removeClass('fc-white').addClass('icon-default');
        if (this.ui.rSystemBtn.data('open') === false) {
          this.ui.rSystemBtn.addClass('panel-heading-white');
        }

        this.ui.uSystemArrow.addClass('fc-white').removeClass('icon-default');

        $('#rsystemname').text('');
        $('#usystemname').text(': ' + this.model.getSystemName());
      }
    },

    verifySystem: function() {
      if (this.tmpSystem === 'reduce-free') {
        svs.tipset.models.play.enableReduceMode();
        this.model.clear();
      } else {
        svs.tipset.models.play.disableReduceMode();
        this.model.setCurrentSystem(this.tmpSystem);
      }
    },

    helpDialogRSystem: function(e) {
      if (svs.tipset.data.config.helpTexts) {
        var _dialog = new svs.components.dialog.Contextual({
          branding: svs.components.dialog.branding.SPORT,
          attachTo: $(e.currentTarget),
          zIndex: 1400,
          title: svs.tipset.data.config.helpTexts.r_system.title,
          message: [
            {
              type: svs.components.dialog.message.TEXT,
              text: svs.tipset.data.config.helpTexts.r_system.body
            }
          ]
        });
        svs.components.dialog.api.add(_dialog);
      }

      e.stopPropagation();
    },

    helpDialogUSystem: function(e) {
      if (svs.tipset.data.config.helpTexts) {
        var _dialog = new svs.components.dialog.Contextual({
          branding: svs.components.dialog.branding.SPORT,
          attachTo: $(e.currentTarget),
          zIndex: 1400,
          title: svs.tipset.data.config.helpTexts.u_system.title,
          message: [
            {
              type: svs.components.dialog.message.TEXT,
              text: svs.tipset.data.config.helpTexts.u_system.body
            }
          ]
        });
        svs.components.dialog.api.add(_dialog);
      }

      e.stopPropagation();
    },

    render: function() {
      svs.tipset.calls.addCall('system ' + this.uid);
      var system = this.model.getCurrentSystem(),
        currentRsystem = null,
        currentUsystem = null;
      if (system) {
        currentRsystem = system.type == 'R' ? system : null;
        currentUsystem = system.type == 'U' ? system : null;
      }
      var noSystem =
        system == null && !svs.tipset.models.play.get('isReduceMode');
      var systems = {
        currentRsystem: currentRsystem,
        currentUsystem: currentUsystem,
        noSystem: noSystem,
        reduceFreeMode: svs.tipset.models.play.get('isReduceMode'),
        rsystem: svs.tipset.models.systems.getRsystem(currentRsystem),
        usystem: svs.tipset.models.systems.getUsystem(currentUsystem),
        branding: svs.tipset.data.gameDefinitions.htmlClass
      };

      if (svs.tipset.data.doRenderTipsBoardAfterModal) {
        svs.tipset.data.doRenderTipsBoardAfterModal = undefined;
      }

      this.$el.html(svs.tipset.templates.system(systems));

      this.bindUIElements();

      if (currentRsystem) {
        this.ui.rSystemBtn.data('open', true);
      } else if (currentUsystem) {
        this.ui.uSystemBtn.data('open', true);
      }

      return this.el;
    }
  });
})();

 })(window);